import { siteInfo, footerLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50 pt-14 md:pt-20 pb-8">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-14">
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-black text-primary-400 font-heading">{siteInfo.name}</span>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
              专注娱乐八卦与争议事件的独立资讯平台，每日追踪全网黑料最新动态。
              坚持独立运营、多方验证，为吃瓜群众提供最真实的爆料内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">浏览</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.topics.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.content.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-6 md:pt-8">
          <div className="mb-4 md:mb-5">
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-500">诚邀优质媒体与内容平台合作，敬请期待</p>
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} {siteInfo.name} · 保留所有权利
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">回到顶部</a>
              <span className="text-xs text-foreground-500">独立运营 · 拒绝公关</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}